import { render } from "./TheHDetail.vue?vue&type=template&id=2bdc420a&scoped=true&ts=true"
import script from "./TheHDetail.vue?vue&type=script&lang=ts"
export * from "./TheHDetail.vue?vue&type=script&lang=ts"

import "./TheHDetail.vue?vue&type=style&index=0&id=2bdc420a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdc420a"]])

export default __exports__